import React, { useEffect } from 'react';
import { GlobalOutlined } from '@ant-design/icons';
import { DatabaseConfig } from '../../../types/database.type';
import { databaseEngines } from '../../../constants/databaseEngine';

interface Step3Props {
  config: DatabaseConfig;
  setConfig: (config: DatabaseConfig) => void;
}

const Step3Security: React.FC<Step3Props> = ({ config, setConfig }) => {
  const selectedEngine = databaseEngines.find((e) => e.id === config.engine);

  // En la arquitectura de Kubiy el cliente se conecta desde fuera de la VPC, así
  // que la BD siempre es accesible por internet (protegida por credencial).
  useEffect(() => {
    if (!config.publicAccess) {
      setConfig({ ...config, publicAccess: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-6">
      {/* Puerto: RDS usa el puerto estándar del motor; no es configurable. */}
      <div className="bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium text-gray-900 dark:text-white text-sm">Puerto</p>
            <p className="text-xs text-gray-500 mt-0.5">Puerto estándar de {selectedEngine?.name}</p>
          </div>
          <p className="font-bold text-gray-900 dark:text-white">{selectedEngine?.defaultPort ?? config.port}</p>
        </div>
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <GlobalOutlined className="text-blue-600 dark:text-blue-400 mt-0.5" />
          <div>
            <p className="font-medium text-blue-900 dark:text-blue-200 mb-1">Acceso por internet</p>
            <p className="text-xs text-blue-800 dark:text-blue-300">
              Tu base de datos tendrá un endpoint accesible desde internet para que puedas
              conectarte desde tu aplicación o herramientas (DBeaver, SQL Server Management Studio,
              etc.). El acceso está protegido por usuario y contraseña.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
        <h4 className="font-semibold text-amber-900 dark:text-amber-200 mb-2 text-sm">Recomendaciones de seguridad</h4>
        <ul className="text-xs text-amber-800 dark:text-amber-300 space-y-1">
          <li>• Usa contraseñas fuertes con caracteres mixtos</li>
          <li>• No compartas las credenciales de conexión</li>
          <li>• Los respaldos automáticos (7 días) vienen incluidos</li>
        </ul>
      </div>
    </div>
  );
};

export default Step3Security;